import { InputBaseComponentProps, TextField, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { SelectValueListItem } from '@src/shared/types/SelectValueListItem'
import { forwardRef } from 'react'
import { FieldError } from 'react-hook-form'
import translateErrorCode from './TranslateError'

interface Props extends InputBaseComponentProps {
  error?: FieldError
  valueList: SelectValueListItem[]
  label?: string
}

const SelectComponent = forwardRef<Props, Props>(function SelectComponent(props, ref) {
  const { error, valueList, label, ...otherProps } = props as Props

  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <TextField
      inputRef={ref}
      label={label}
      error={error !== undefined}
      helperText={error ? translateErrorCode(error) : ' '}
      variant="outlined"
      fullWidth
      select
      slotProps={{
        inputLabel: { shrink: true },
        select: {
          native: true,
          inputProps: { ...otherProps },
        },
      }}
    >
      <option aria-label="None" value="" style={{ display: 'none' }} hidden />
      {valueList?.map((item) => (
        <option
          style={{
            color: item.label.toString().includes('**') ? theme.palette.text.secondary : 'none',
          }}
          key={item.value}
          value={item.value}
        >
          {t(item.label.toString(), item.label.toString())}
        </option>
      ))}
    </TextField>
  )
})

export default SelectComponent
